export const INT = 'Int32'
export const DECIMAL = 'Decimal'
export const DATETIME = 'Datetime'
export const MEASUREDATETIME = 'MeasureDateTime'
